import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const Plus = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M6 11.98H18" />
      <path d="M11.975 6L11.975 18" />
    </svg>
  );
};
